import React, { useState } from "react";

// Переиспользуемая кнопка массового подтверждения (у Prom -- инлайн <button>
// с обработчиком, продублированный по месту, без индикации загрузки).
// className по умолчанию рассчитан на страницы с темой .rozetka-page
// (RozetkaPage.css); единственный текущий потребитель -- RozetkaAttributeMappingPanel.jsx.
const BulkApproveButton = ({ label, onApprove, onResult, onError, disabled = false, className = "rzm-btn" }) => {
    const [loading, setLoading] = useState(false);

    const handleClick = async () => {
        setLoading(true);
        try {
            const result = await onApprove();
            onResult?.(result);
        } catch (error) {
            onError?.(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <button type="button" className={className} disabled={loading || disabled} onClick={handleClick}>
            {loading ? "Подтверждаем…" : label}
        </button>
    );
};

export default BulkApproveButton;
